import styled from 'styled-components';
import { Box, Grid } from '@mui/material';

export const Container = styled(Box)`
  padding: 48px 24px;
  color: #000000;
  min-height: 100vh;
`;

export const ContentWrapper = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
`;

export const PriceArea = styled(Box)`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 16px;
`;

export const TagList = styled(Box)`
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
